import PropTypes from "prop-types";
import SelectField from "./SelectField";
import InputField from "./InputField";
import RadioField from "./RadioField";
import UploadField from "./UploadField";
import ButtonField from "./ButtonField";

const Fields = ({ type, ...props }) => {
  switch (type) {
    case "button":
      return <ButtonField {...props} />;
    case "radio":
      return <RadioField inputType={type} {...props} />;
    case "text":
    case "email":
    case "tel":
      return <InputField {...props} />;
    case "textarea":
      return <InputField multiline rows={5} {...props} />;
    case "select":
      return <SelectField {...props} />;
    case "upload":
      return <UploadField {...props} />;
    default:
      return null;
  }
};

Fields.propTypes = {
  type: PropTypes.oneOf(["text", "textarea", "select", "multiselect", "radio", "email", "tel", "button", "upload"])
    .isRequired,
};

export default Fields;
